import { mediaCards } from '@/pages/home/mocks/data';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-3">
            热门视频
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">吃瓜视频精选</h2>
          <p className="text-foreground-500 mt-2 text-sm">最新最热的八卦视频，视觉吃瓜更过瘾</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaCards.map((card) => (
            <div key={card.id} className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer">
              <div className="relative overflow-hidden aspect-video">
                <img
                  src={card.coverUrl}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-white transition-all">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-white text-xs font-medium rounded-md whitespace-nowrap">
                  {card.tag}
                </span>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 bg-black/60 text-white text-xs rounded whitespace-nowrap">
                  {card.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-relaxed mb-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{card.heat} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}